// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Components
import { Grid } from 'src/components/HTKit/Grid';
import { Badge, BADGE_TYPES } from 'src/components/Elements/Badge';
import Avatar from 'src/components/HTKit/Elements/Avatar';
import TechInfo, { TechStats } from './TechStats';
// Styles
import styles from './styles.scss';

const TechProfileHero = ({ techInfo, techName, onRatingClick }) => {
  if (!techInfo || !Object.keys(techInfo).length) return null;
  const { id, profilePicture } = techInfo;

  return (
    <div className={cn('paddingY-large', styles.container)}>
      <Grid.Fluid>
        <Grid.Row classes={styles.techInfoRowContainer}>
          <Grid.Column sm={4} mdOffset={1} md={6} lgOffset={0} lg={6} classes={styles.leftColumn}>
            <Grid.Row classes={styles.customRow}>
              <div
                className={cn(
                  'flexDirectionColumn flex text-align-center',
                  styles.infoWrapperMobile,
                )}
              >
                <Avatar
                  image={profilePicture && profilePicture.medium}
                  className={styles.techImage}
                  name={techName}
                  imageAlt={techName}
                />
                <h3 className="paddingBottom-tiny1 showMobileTablet">{techName}</h3>
                <Badge type={BADGE_TYPES.CONFIRMED} variant="solid" size="medium">
                  Tech ID: {id}
                </Badge>
              </div>

              {/* Mobile Stats */}
              <TechStats techInfo={techInfo} className="paddingY-medium2 showMobileTablet" />

              {/* Desktop Tech Info */}
              <div lg={4} className={styles.infoContainer}>
                <h3 className="paddingBottom-medium">{techName}</h3>
                <TechInfo techInfo={techInfo} />
              </div>
            </Grid.Row>
          </Grid.Column>
          {/* Desktop Tech Stats */}
          <Grid.Column lg={6} classes="justifyContentCenter alignItemsCenter flex">
            <div className={styles.statsContainer}>
              <TechStats techInfo={techInfo} onRatingClick={onRatingClick} />
            </div>
          </Grid.Column>
        </Grid.Row>

        {/* Mobile Tech Info */}
        <Grid.Row classes={styles.mobileTechInfoContainer}>
          <TechInfo
            techInfo={techInfo}
            className={cn(
              'paddingTop-medium paddingBottom-tiny1 paddingLeft-tiny1',
              styles.techInfo,
            )}
          />
        </Grid.Row>
      </Grid.Fluid>
    </div>
  );
};

TechProfileHero.propTypes = {
  techInfo: PropTypes.object,
  techName: PropTypes.string,
  onRatingClick: PropTypes.func,
};

export default TechProfileHero;
